import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useConfiguracoesSistemaPublicas } from "../utils/configuracoesSistema";

interface RecursoEmpresaRouteProps {
  recurso: "tef" | "fiscal" | "configuracoes-pdv";
  children: ReactNode;
}

export function RecursoEmpresaRoute({ recurso, children }: RecursoEmpresaRouteProps) {
  const config = useConfiguracoesSistemaPublicas();
  const liberado = recurso === "tef"
    ? config.tefMenu
    : recurso === "fiscal"
      ? config.fiscalMenu && config.fiscalIntegracao
      : config.tefMenu || config.fiscalMenu;
  return liberado ? children : <Navigate to="/vendas" replace />;
}
